/**
 * Model to hold the count of a product sold
 */
export class ProductCount {
    public id: string;
    public name: string;
    public productTypeId: string;
    public productTypeName: string;
    public count: number = 0;

    public deserialize(json: Object): ProductCount {
        this.id = json['id'];
        this.name = json['name'];
        this.productTypeId = json['productTypeId'];
        this.productTypeName = json['productTypeName'];
        this.count = json['count'];

        return this;
    }
}
